
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.33.51L8 .4a11 11 0 00-2.49 3.41 9.71 9.71 0 01-1-.34 10.5 10.5 0 01-1.5-.75A8.77 8.77 0 017.33.51zM8.66.68v3.64A11.86 11.86 0 016.12 4 10.17 10.17 0 018.66.68zM9.28.66A10.23 10.23 0 0111.85 4a12.14 12.14 0 01-2.57.34zM9.92.4a8.54 8.54 0 015 2.3 11.26 11.26 0 01-2.45 1.1A11.1 11.1 0 009.92.4zM12.53 14A10.81 10.81 0 0115 15.19a8.57 8.57 0 01-4.74 2.36l-.37.05c.2-.18.4-.38.59-.58A11.13 11.13 0 0012.53 14zM11.93 13.86a10.66 10.66 0 01-1.85 2.74c-.26.26-.52.51-.8.75v-3.86a11.07 11.07 0 012.65.37zM8.66 13.49v3.83A10.24 10.24 0 016 13.85a11.62 11.62 0 012.29-.35zM5.43 14A11 11 0 008 17.6a8.65 8.65 0 01-5.1-2.43A10.83 10.83 0 015.43 14zM4.35 9.22a12 12 0 00.83 4.23A11.67 11.67 0 002.5 14.7 8.66 8.66 0 01.35 9.22zM8.66 9.22v3.65H8.3a12.48 12.48 0 00-2.52.39 11.46 11.46 0 01-.81-4zM9.28 9.22H13a11.48 11.48 0 01-.82 4.06 12.08 12.08 0 00-2.9-.41zM13.62 9.22h4a8.65 8.65 0 01-2.18 5.51 11 11 0 00-2.69-1.27 12.08 12.08 0 00.87-4.24zM17.64 8.59h-4a11.76 11.76 0 00-.9-4.22 11.39 11.39 0 002.65-1.22 8.57 8.57 0 012.25 5.44zM13 8.59H9.28V4.94a12.07 12.07 0 002.83-.39A11.37 11.37 0 0113 8.59zM8.66 4.94v3.65H5c0-.26 0-.53.06-.79a11.34 11.34 0 01.82-3.24 12.52 12.52 0 002.78.38zM5.25 4.38a12 12 0 00-.84 3.39c0 .27 0 .55-.06.82h-4a8.64 8.64 0 012.26-5.42A11.1 11.1 0 004.33 4c.3.17.61.28.92.38z","fill":"var(--map-icons)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/map_icons/map.svg